// extracted by mini-css-extract-plugin
export default {"home":"home_home__qA4gR","intro":"home_intro__48X8-","home_img":"home_home_img__Q36oz","home_name":"home_home_name__HV-Xi","education":"home_education__rFZg2"};